import React from "react";
import "./Background.css"; // We'll define the styles in a CSS file

const Background = () => {
    return (
        <div className="background">
            {/* {Array.from({ length: 10 }).map((_, index) => (
                <span key={index}></span>
            ))} */}
        </div>
    );
};

export default Background;
